import { render } from "./legoDropHolderExtend.vue?vue&type=template&id=2751832d&scoped=true"
import script from "./legoDropHolderExtend.vue?vue&type=script&lang=js"
export * from "./legoDropHolderExtend.vue?vue&type=script&lang=js"

import "./legoDropHolderExtend.vue?vue&type=style&index=0&id=2751832d&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2751832d"],['__file',"src/components/lego/extend/legoDropHolderExtend.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2751832d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2751832d', __exports__)) {
    api.reload('2751832d', __exports__)
  }
  
  module.hot.accept("./legoDropHolderExtend.vue?vue&type=template&id=2751832d&scoped=true", () => {
    api.rerender('2751832d', render)
  })

}


export default __exports__